import { Modal } from '@ver-uds/react';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import DashboardForgotPasswordModalForm from './DashboardForgotPasswordModalForm/DashboardForgotPasswordModalForm';
import { ForgotPasswordModalFormValues } from '../../../constants/Dashboard';

export type DashboardForgotPasswordModalProps = {
  isOpen: boolean;
  setIsOpen: (show: boolean) => void;
};

const DashboardForgotPasswordModal = ({ isOpen, setIsOpen }: DashboardForgotPasswordModalProps): JSX.Element => {
  const [errorMessage, setErrorMessage] = useState<string>('');

  // Define form
  const formMethods = useForm<ForgotPasswordModalFormValues>({
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
  });

  // Set modal's app element
  if (!document.getElementById('root')) {
    const root = document.createElement('div');
    root.id = 'root';
    document.body.appendChild(root);
    Modal.setAppElement('#root');
  }

  // Close and reset all values
  const onClose = (): void => {
    setIsOpen(false);
    setErrorMessage('');
    formMethods.reset();
  };

  return (
    <>
      <Modal id="forgot-password-account-modal" header="Reset Password" open={isOpen} close={onClose}>
        <DashboardForgotPasswordModalForm
          formMethods={formMethods}
          errorMessage={errorMessage}
          setErrorMessage={setErrorMessage}
          onClose={onClose}
        />
      </Modal>
    </>
  );
};

export default DashboardForgotPasswordModal;
